export const ROUTES = {
  CONVERATION_BUILDER: 'conversationBuilder',
  BOT_PLATFORM: 'botPlatform',
  INTENT_MANAGER: 'intentManager',
  LANDING: 'landing',
  PERFORMANCE_OPTIMIZER: 'performanceoptimizer',
  DATA_TRANSPORTER: 'datatransporter',
  CONVERSATION_ASSIST: 'conversationAssist',
  AIWB: 'aiwb',
  MC: 'mc',
  IHU: 'ihu',
};

export const CB_ROUTES = {
  BOT_BUILDER: 'botBuilder', // bot builder
  KNOWLEDGE_BASE: 'knowledgeBase', // knowledge base
  DOMAINS: 'intentBuilder', // intent builder
  ANALYTICS: 'botAnalytics', // bot analytics
  SYS_ADMIN: 'botStatus', // bot status
  ORG_MGMT: 'botAccounts', // bot accounts
  BYOLLM: 'byollm',
};

export const ALL_ROUTES = { ...ROUTES, ...CB_ROUTES };

export const ALL_ROUTES_INVERT = Object.fromEntries(
  Object
    .entries(ALL_ROUTES)
    .map(([key, value]) => [value, key]),
);
